import React from 'react';
import RequestPanelNewContainer from './RequestPanelNewContainer';
import RequestPanelExistingContainer from './RequestPanelExistingContainer';

const RequestPanelContainer = ({
  category,
  className,
  code,
  children,
  compact,
  isNew,
  onChange,
  url,
}) => {
  const Component = isNew ? RequestPanelNewContainer : RequestPanelExistingContainer;
  return (
    <Component category={category} className={className} code={code} compact={compact} onChange={onChange} url={url}>
      {children}
    </Component>
  );
};

export default RequestPanelContainer;
